import { useTranslation } from "react-i18next";
import warningIcon from "@/shared/assets/img/shared/alert-warning.png";
import { Button } from "../";

interface Props {
  onSaveAndLeave: () => void;
  onLeaveWithout: () => void;
  onStay: () => void;
  isSaving?: boolean;
}

export default function UnsavedChangesModal({ onSaveAndLeave, onLeaveWithout, onStay, isSaving = false }: Props) {
  const { t } = useTranslation("Common");

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen surface-backdrop blur-level-1 flex justify-center items-center z-[10200]"
      onClick={onStay}>
      <div
        className="p-8 bg-white rounded-2xl prompt-box-shadow flex flex-col items-center gap-6 w-[340px] prompt-warning-gradient"
        onClick={(e) => e.stopPropagation()}>
        <img src={warningIcon} alt="warning" className="w-10 aspect-square" />
        <div className="flex flex-col gap-1">
          <h3 className="text-body-bold-md text-center content-base-primary">{t("unsaved.title")}</h3>
          <p className="text-body-regular-sm text-center content-base-secondary">{t("unsaved.text")}</p>
        </div>

        <div className="flex flex-col gap-3 w-full">
          <Button variant="primary" size="md" onClick={onSaveAndLeave} disabled={isSaving}>
            {isSaving ? t("prompt_form.submitting") : t("unsaved.saveAndLeave")}
          </Button>
          <Button variant="danger" size="md" onClick={onLeaveWithout} disabled={isSaving}>
            {t("unsaved.leaveWithout")}
          </Button>
          <Button variant="secondary" size="md" onClick={onStay} disabled={isSaving}>
            {t("unsaved.stay")}
          </Button>
        </div>
      </div>
    </div>
  );
}
